import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CoursesService } from 'src/app/services/courses.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PlayerService } from 'src/app/services/player.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { EventService } from 'src/app/services/event.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { ScorecardPreviewDialogComponent, ScorecardUploadDialogData } from '../scorecard-preview-dialog/scorecard-preview-dialog.component';

@Component({
  selector: 's18-scorecard-lookup',
  templateUrl: './scorecard-lookup.component.html',
  styleUrls: ['./scorecard-lookup.component.scss']
})
export class ScorecardLookupComponent implements OnInit {
  @Input() course_id: string = "";
  @Input() inModal: boolean = false;
  @Output() close = new EventEmitter<any>();
  requestingRevision: boolean = false;
  common = {
    course_name: "",
    address: "",
    state: "",
    city: "",
    zip: "",
    phone_number: "",
    fax_number: "",
    email: "",
    url: ""
  };
  commonStr: string = "";
  savingCourse: boolean = false;
  editing: boolean = false;
  message: string = "";
  scorecard: any[];
  hole_nbr_front: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  hole_nbr_back: number[] = [10, 11, 12, 13, 14, 15, 16, 17, 18];

  constructor(
    private courseService: CoursesService,
    private eventService: EventService,
    private localStorageService: LocalStorageService,
    private route: ActivatedRoute,
    private playerService: PlayerService,
    private router: Router,
    private snackbar: MatSnackBar,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    var player = this.playerService.getLoggedInPlayerInfo();
    if (!player) {
      this.localStorageService.set("forward_url", this.router.url);
      this.router.navigateByUrl("/login");
      return;
    }
    if (this.course_id != "") {
      this.getScorecard();
    } else {
      this.route.params.subscribe(params => {
        this.course_id = params["course_id"];
        this.getScorecard();
      });
    }
  }

  allowEdits() {
    return this.isAdmin() && !this.inModal;
  }

  isAdmin() {
    var player = this.playerService.getLoggedInPlayerInfo();
    return +player.is_admin === 1;
  }

  goToEdit() {
    this.close.emit("close");
    this.router.navigateByUrl("/scorecard/" + this.course_id);
  }

  updateArray(array: any[], i: number, value: number) {
    array[i] = value;
    console.log(array);
  }

  getScorecard() {
    this.editing = false;
    this.courseService.getCourseScorecard(this.course_id)
      .subscribe(resp => {
        this.scorecard = JSON.parse(resp.d);
        console.log(this.scorecard);
        this.setCommonVariables();
        this.createYardsArray();
      }, err => {
        console.log(err);
      });
  }

  setCommonVariables() {
    this.common.course_name = this.scorecard[0].coursename;
    this.common.address = this.scorecard[0].streetaddress;
    this.common.city = this.scorecard[0].city;
    this.common.state = this.scorecard[0].stateorregion;
    this.common.zip = this.scorecard[0].zip;
    this.common.phone_number = this.scorecard[0].phonenumber;
    this.common.fax_number = this.scorecard[0].faxnumber;
    this.common.email = this.scorecard[0].emailaddress;
    this.common.url = this.scorecard[0].url;
    this.commonStr = JSON.stringify(this.common);
  }

  commonChanged() {
    return (this.commonStr != JSON.stringify(this.common));
  }

  updateAll(event, component_name) {
    console.log(event);
    var value = event.srcElement.value;
    this.scorecard.forEach(card => {
      card[component_name] = value;
    });
  }

  createYardsArray() {
    this.scorecard.forEach(x => {
      x.isNew = false;
      x.remove = false;
      // WI 82: per-nine slope/rating can be NULL in the DB for courses whose
      // front/back values were never set. Coerce null/undefined to '' so the
      // inline-edit field shows blank (not "null") and offers the edit pencil.
      this.normalizePerNineForDisplay(x);
      let par_array: { hole_nbr: number, value: string }[] = [];
      let hcp_array: { hole_nbr: number, value: string }[] = [];
      let yards_array: { hole_nbr: number, value: string }[] = [];
      this.hole_nbr_front.forEach(y => {
        par_array.push({ hole_nbr: y, value: x['par_' + y] });
        hcp_array.push({ hole_nbr: y, value: x['hdcp_' + y] });
        yards_array.push({ hole_nbr: y, value: x['yards_' + y] });
      });
      x.front_par = par_array;
      x.front_hcp = hcp_array;
      x.front_yards = yards_array;

      par_array = [];
      hcp_array = [];
      yards_array = [];
      this.hole_nbr_back.forEach(y => {
        par_array.push({ hole_nbr: y, value: x['par_' + y] });
        hcp_array.push({ hole_nbr: y, value: x['hdcp_' + y] });
        yards_array.push({ hole_nbr: y, value: x['yards_' + y] });
      });
      x.back_par = par_array;
      x.back_hcp = hcp_array;
      x.back_yards = yards_array;

    });
  }

  addTeeBox(index: number) {
    this.editing = true;
    var teeNumbers = this.scorecard.map(x => +x.teenumber);
    var newTeeNumber = teeNumbers.length > 0 ? Math.max.apply(null, teeNumbers) + 1 : 1;
    var newTee = JSON.parse(JSON.stringify(this.scorecard[index]));
    newTee.isNew = true;
    newTee.teenumber = newTeeNumber.toString();
    newTee.tees_id = newTee.course_id + "-" + newTeeNumber;
    this.scorecard.splice(index, 0, newTee);
  }

  requestRevision() {
    this.message = "";
    this.requestingRevision = true;
    this.courseService.requestCourseRevision(this.course_id)
      .subscribe(resp => {
        this.requestingRevision = false;
        var response = JSON.parse(resp.d).response;
        if (response == "ok") {
          this.message = "Revision request sent succesfully!";
        }
      }, err => {
        this.requestingRevision = false;
        this.message = err;
      });
  }

  edit() {
    this.editing = true;
  }

  save() {
    this.savingCourse = true;
    console.log(this.scorecard);
    this.updateFromCardsArray();
    // WI 82: convert blank per-nine fields back to null (never 0) so an unset
    // front/back slope/rating stays unset rather than being written as zero,
    // which the 9-hole handicap fallback treats differently from "unavailable".
    this.scorecard.forEach(tee => this.normalizePerNineForSave(tee));
    this.showSnackbar(this.course_id, '');
    this.courseService.saveCourseUpdates(this.scorecard)
      .subscribe(resp => {
        var response = JSON.parse(resp.d).response;
        if (response == "ok") {
          this.message = "Save completed!";
        }
        this.savingCourse = false;
        this.editing = false;
        this.getScorecard();
      }, err => {
        console.log(err);
        this.savingCourse = false;
        this.editing = false;
      })
  }

  showSnackbar(course_id, text) {
    if (this.savingCourse) {
      if (text === '') {
        text = "Updating all non-started round, this could take a minute ...";
      }
      var snackbarRef = this.snackbar.open(text, null, { duration: 1000 });
      snackbarRef.afterDismissed()
        .subscribe(() => {
          this.checkStatus(course_id);
        });
    }
  }

  checkStatus(guid) {
    this.eventService.getProcessStatus(guid)
      .subscribe(resp => {
        var status = JSON.parse(resp.d).status;
        this.showSnackbar(guid, status);
      });
  }

  // WI 82: the four per-nine slope/rating fields that are now editable on the page.
  private readonly perNineFields = ['front_slope', 'front_rating', 'back_slope', 'back_rating'];

  /**
   * WI 82: on load, coerce null/undefined per-nine values to '' so the inline-edit
   * control renders blank (not the string "null") and shows its edit pencil.
   */
  normalizePerNineForDisplay(tee: any) {
    this.perNineFields.forEach(f => {
      if (tee[f] === null || tee[f] === undefined) {
        tee[f] = '';
      }
    });
  }

  /**
   * WI 82: before saving, convert an empty/blank per-nine value back to null so an
   * unset front/back slope/rating stays unset rather than being written as 0.
   * Populated values are left untouched (the backend persists them as-is).
   */
  normalizePerNineForSave(tee: any) {
    this.perNineFields.forEach(f => {
      const v = tee[f];
      if (v === '' || v === null || v === undefined) {
        tee[f] = null;
      }
    });
  }

  updateFromCardsArray() {    this.scorecard.forEach(x => {
      x.front_par.forEach((y) => {
        x['par_' + y.hole_nbr] = y.value;
      });

      x.front_hcp.forEach((y) => {
        x['hdcp_' + y.hole_nbr] = y.value;
      });

      x.front_yards.forEach((y) => {
        x['yards_' + y.hole_nbr] = y.value;
      });

      x.back_par.forEach((y) => {
        x['par_' + y.hole_nbr] = y.value;
      });

      x.back_hcp.forEach((y) => {
        x['hdcp_' + y.hole_nbr] = y.value;
      });

      x.back_yards.forEach((y) => {
        x['yards_' + y.hole_nbr] = y.value;
      });
    });
  }

  onUploadScorecard(): void {
    const dialogData: ScorecardUploadDialogData = { course_id: this.course_id };
    const dialogRef = this.dialog.open(ScorecardPreviewDialogComponent, {
      width: '900px',
      disableClose: true,
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.getScorecard();
      }
    });
  }
}
